import { RouterContext, type RouterContextValue } from "@src/context/router/RouterContext";
import * as React from "react";

export const useRouter = (): RouterContextValue => {
    return React.useContext(RouterContext);
};
